import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    accessibleLabel: string;
    standardResults: string;
    standardResultsWithCount: (count: number) => string;
    mediaIntelligence: string;
    mediaIntelligenceWithCount: (count: number) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Accessible label for the search result category tabs */
            accessibleLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearchTabBar.accessibleLabel?c=1ea3wlhclvwmx", defaultMessage: "Search result categories" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the standard results tab */
            standardResults: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearchTabBar.standardResults?c=33g0wpc6wzfan", defaultMessage: "Standard Results" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label for the standard results tab with count */
            standardResultsWithCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "QuickSearchTabBar.standardResultsWithCount?c=2xxv4bx296rgv", defaultMessage: "Standard Results ({count})" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the AI results tab */
            mediaIntelligence: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearchTabBar.mediaIntelligence?c=lmyia2b8ckk1", defaultMessage: "AI Results" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label for the AI results tab with count */
            mediaIntelligenceWithCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "QuickSearchTabBar.mediaIntelligenceWithCount?c=sopm9f4w7wam", defaultMessage: "AI Results ({count})" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
